import React from 'react'

export default function Forgotpassword() {
  return (
    <div>Forgotpassword</div>
  )
}
